import { $host } from './index';
import { AppDispatch } from '@store';
import { isSpinAC, notificationModalAC } from '@store/reducers/app';
import { activePanelAC, counterpartiesAC, counterpartiesListAC } from '@store/reducers/counterparties';

const END_POINT = '/client';

const getAllCounterpartiesApi =
  (page: string | number, query: any, pageSize?: number) => async (dispatch: AppDispatch) => {
    try {
      dispatch(isSpinAC(true));
      const { data } = await $host.post(`${END_POINT}/counterparty/?page=${page}&page_size=${pageSize}`, query);
      dispatch(counterpartiesListAC(data));
      dispatch(counterpartiesAC(data.results));
    } finally {
      dispatch(isSpinAC(false));
    }
  };

const createCounterpartyApi = (query: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/counterparty/create`, query);
    return data;
  } finally {
    dispatch(isSpinAC(false));
  }
};

const deleteCounterpartyApi = (id: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/counterparty/delete/${id}`);

    return data;
  } finally {
    dispatch(isSpinAC(false));
  }
};

const authCounterpartyActionApi = (query: any) => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(`${END_POINT}/counterparty/auth-action`, query);
    if (data) {
      dispatch(activePanelAC(''));
      dispatch(getAllCounterpartiesApi(1, {}, 10));
    }
  } finally {
    dispatch(isSpinAC(false));
  }
};

const downloadCounterpartyListApi = () => async (dispatch: AppDispatch) => {
  try {
    dispatch(isSpinAC(true));
    const { data } = await $host.post(
      `${END_POINT}/counterparty/download/file`,
      {},
      {
        responseType: 'arraybuffer',
      }
    );
    const url = window.URL.createObjectURL(new Blob([data], { type: 'application/xlsx' }));
    const link = document.createElement('a');
    link.href = url;
    link.setAttribute('download', 'Список контрагентов.xlsx');
    link.click();
  } catch (error: any) {
    dispatch(
      notificationModalAC({
        isOpen: true,
        message: error?.response?.data?.detail || error?.response?.data?.message,
        type: 'error',
      })
    );
  } finally {
    dispatch(isSpinAC(false));
  }
};

export {
  getAllCounterpartiesApi,
  createCounterpartyApi,
  deleteCounterpartyApi,
  authCounterpartyActionApi,
  downloadCounterpartyListApi,
};
